import { ProvideNames } from "#shared/statics";
import { useEmbedded } from "~/composables/states";

export default defineNuxtRouteMiddleware(async (to, from) => {
    if (to.query.embedded !== undefined) {
        useEmbedded().value = true;
    }

    if (useFeatureState('cfg-campaign-parameters').value == true) {
        const parameters: Array<string> = useFeatureValue('cfg-campaign-parameters').value?.parameters;
        const campaigns = [];
        const existing = new URLSearchParams(useABConfigCookie().value?.context?.campaigns as string ?? '');

        for (const param of parameters) {
            if (param && to?.query?.[param]) {
                campaigns.push(`${param}=${to?.query?.[param]?.toString()}`);
            } else if (param && existing?.get(param)) {
                campaigns.push(`${param}=${existing?.get(param)?.toString()}`);
            }
        }

        if (campaigns?.length > 0) {
            setABContextVariable('campaigns', campaigns.join('&'));
            if(useABConfigCookie() && useABConfigCookie().value)
                useABConfigCookie().value.context = {
                ...useABConfigCookie().value.context,
                campaigns: campaigns.join('&')
            }
        }
    }

    if (import.meta.client) {
        if (to.fullPath?.toLowerCase()?.match(/.*(\?|&)campaignid.*/)) {
            await changeToStoreById(ProvideNames.DEFAULT_CENTRAL_STORE.id, useStoreCookie().value ?? '', 'campaignid');
            delete to.query['campaignid'];
        } else if (to.fullPath?.toLowerCase()?.match(/.*(\?|&)branch_id=.*/)) {
            let search = new URLSearchParams('?' + to?.fullPath?.toLowerCase()?.split('?').at(1));
            let branchId = search.get('branch_id') as string;
            branchId = branchId?.startsWith('e_') ? branchId : ('e_' + branchId)
            useStoreCookie().value = branchId;
            await changeToStoreById(branchId, useStoreCookie().value ?? '', 'branch_id');
            delete to.query['branch_id'];

            const storeSlug = to.params?.storeslug;
            if (storeSlug && typeof storeSlug === 'string' && storeSlug != '') {
                const store = await $fetch<Store>('/api/store', {
                    query: {
                        storeId: branchId,
                    },
                });

                return navigateTo({
                    path: to.path.replace(/(^\/markt\/)(\w*)/, `$1${store?.storeLink?.toLowerCase()}`),
                    query: to.query,
                });
            }
        }
    }

    if (to.query['changer']) {
        useState('isChanger').value = to.query['changer'].toString();
    }
});
